const OPEN_DOCUMENTS_LABEL = "open documenten";

export function formatOpenDocumentsTitle(
    visibleCount: number,
    totalCount: number,
    isFiltered: boolean
): string {
    if (!isFiltered) return `${totalCount} ${OPEN_DOCUMENTS_LABEL}`;
    return `${visibleCount} van ${totalCount} ${OPEN_DOCUMENTS_LABEL}`;
}

export function daysUntilDueToColorClass(days: number | null): string {
    if (days === null) return "text-black";
    if (days < 0) return "text-red-700 font-medium";
    if (days < 7) return "text-yellow-600 font-medium";
    return "text-gray-600";
}

export const formatDateDDMMYY = (isoDate: string): string => {
    const date = new Date(isoDate);
    return date.toLocaleDateString("nl-NL", {
        day: "2-digit",
        month: "2-digit",
        year: "2-digit",
    });
};


const dayWord = (n: number) => (n === 1 ? "dag" : "dagen");

export function formatDueDateLabel(dueDate: string | null, daysUntilDue: number | null): string {
    if (dueDate == null) return "-";
    const datePart = `(${formatDateDDMMYY(dueDate)})`;
    if (daysUntilDue == null) return datePart;

    if (daysUntilDue < 0) {
        const days = Math.abs(daysUntilDue);
        return `Verlopen ${days} ${dayWord(days)} geleden ${datePart}`;
    }
    if (daysUntilDue === 0) return `Vandaag ${datePart}`;
    return `Binnen ${daysUntilDue} ${dayWord(daysUntilDue)} ${datePart}`;
}
